<template>
  <a-spin :spinning="confirmLoading">
    <div>
      <a-form :form="form" slot="detail">
<!--        <a-row>-->
<!--          <a-col :span="24" class="lineh">-->
<!--            <b>项目名称:</b><br/>-->
<!--            项目名称项目名称项目名称项目名称项目名称项目名称项目名称-->
<!--          </a-col>-->
<!--        </a-row>-->
<!--        <a-row>-->
<!--          <a-col :span="24">-->
<!--            <b>项目编号:</b>2333211113333-->
<!--          </a-col>-->
<!--        </a-row>-->
        <div class="Section0" style="layout-grid:15.6000pt;">
          <p class=MsoNormal align=center
             style="margin-bottom:7.8000pt;mso-para-margin-bottom:0.5000gd;mso-pagination:none;text-align:center;mso-line-height-alt:12pt;">
            <b>
				<span
          style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;mso-font-kerning:0.0000pt;">
					<font face="黑体">山东师范大学招标采购项目验收报告</font>
				</span>
            </b>
            <b>
				<span
          style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;mso-font-kerning:0.0000pt;">
					&nbsp;
				</span>
            </b>
          </p>
          <p class=MsoNormal align=center style="mso-pagination:none;text-align:center;mso-line-height-alt:12pt;">
            <span
              style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <b>
				<span
          style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
<!--					<font face="宋体">编号：{{ysbgNo}}</font>-->
				</span>
            </b>
            <b>
				<span
          style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;mso-font-kerning:0.0000pt;">
					&nbsp;
				</span>
            </b>
          </p>
          <table class=MsoNormalTable align=center border=1 cellspacing=0
                 style="border-collapse:collapse;width:459.0000pt;mso-table-layout-alt:fixed;border:none;mso-border-left-alt:0.5000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;mso-border-insideh:0.5000pt solid windowtext;mso-border-insidev:0.5000pt solid windowtext;mso-padding-alt:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;">
            <tr style="height:22.7000pt;">
              <td width=134 valign=center colspan=2
                  style="width:90.75pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">合同编号</span>
                  <span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
						</span>
                </p>
              </td>
              <td width=245 valign=center colspan=2
                  style="width:147.4000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;">
						<span
              style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
                             {{model.contractNo}}
						</span>
                </p>
              </td>
              <td width=135 valign=center
                  style="width:81.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">项目名称</span>
                  <span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							&nbsp;
						</span>
                </p>
              </td>
              <td width=249 valign=center
                  style="width:149.8500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;">
						<span
              style="line-height:16px;font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
                {{model.budgetAddmainName}}
						</span>
                </p>
              </td>
            </tr>
            <tr style="height:22.7000pt;">
              <td width=134 valign=center colspan=2
                  style="width:80.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">中标单位</span>

                </p>
              </td>
              <td width=245 valign=center colspan=2
                  style="width:147.4000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;">
						<span
              style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
						{{model.zbdw}}
						</span>
                </p>
              </td>
              <td width=135 valign=center
                  style="width:81.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">合同金额(万)</span>
                </p>
              </td>
              <td width=249 valign=center
                  style="width:149.8500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;">
							<span
                style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
                {{model.zbPrice}}(本次验收金额:{{model.ysMoney}})
						</span>
                </p>
              </td>
            </tr>
            <tr style="height:22.7000pt;">
              <td width=134 valign=center colspan=2
                  style="width:80.7500pt;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <div class=MsoNormal align=center style=";margin:8px 0;text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">项目类别</span>

                </div>
              </td>
              <td width=245 valign=center colspan=2
                  style="width:147.4000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
		<span
      style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
             {{model.projectType}}
              </span>
                </p>
              </td>
              <td width=135 valign=center
                  style="width:81.0000pt;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">完工日期</span>

                </p>
              </td>
              <td width=249 valign=center
                  style="font-size:14px;color:black;text-align:center;width:149.8500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
              {{model.projectFinishtime}}
              </td>
            </tr>
            <tr style="height:22.7000pt;">
              <td width=134 valign=center colspan=2
                  style="width:80.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font style="color:red">*</font>验收方式</span>

                </p>
              </td>
              <td width=245 valign=center colspan=2
                  style="width:147.4000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
<!--                <a-form-item label="" style="margin:0 0;">-->
<!--                <a-select-->
<!--                   v-decorator="['ysType',validatorRules.ysType]"-->
<!--                  placeholder="请选择验收方式"-->
<!--                  style="width: 200px;"-->
<!--                  :options="yanshouOptions"-->
<!--                ></a-select>-->
<!--                </a-form-item>-->
                {{yanshou.ysType=="1"?"自行验收":"委托验收"}}
              </td>
              <td width=135 valign=center
                  style="width:81.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:Arial;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font style="color:red">*</font>验收日期</span>
                </p>
              </td>
              <td width=249 valign=center
                  style="width:149.8500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <a-form-item style="margin:0 0;" >
<!--                <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择验收日期"-->
<!--                        class="query-group-cust"   v-decorator="['acceptanceTime',validatorRules.acceptanceTime]" :disabled-date="disabledYanShouDate"></j-date>-->
                  {{model.acceptanceTime}}
                </a-form-item>
              </td>
            </tr>


            <tr style="height:70.4500pt;page-break-inside:avoid;">
              <td width=134 valign=center colspan=2
                  style="width:80.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);letter-spacing:1.5000pt;font-size:12.0000pt;mso-font-kerning:14.0000pt;"><font style="color:red">*</font>验收内容</span>
                </p>
              </td>
                <td width=686 valign=top colspan=5
                    style="width:411.7500pt;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                    {{model.ysContent}}
                </td>
            </tr>

            <tr style="height:50.8000pt;">
              <td width=63 valign=center rowspan=3 style="width:80pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
              <span style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';
letter-spacing:1.5000pt;font-size:12.0000pt;mso-font-kerning:14.0000pt;">
                <font face="宋体">验</font>
                <font face="宋体">收</font>
                <font face="宋体">小</font>
                <font face="宋体">组</font>
                <font face="宋体">意</font> <font face="宋体">见</font></span><span style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';
letter-spacing:1.5000pt;font-size:12.0000pt;mso-font-kerning:14.0000pt;"></span></p>
              </td>
              <td width=549 valign=top colspan=5 style="width:411.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal style="margin-top:10px;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font style="color:red">*</font>验收结论性意见：</span>
                </p>
                <p v-if="genQcode">

                </p>
                <div v-else style="color:black;font-size:20px;margin:20px;font-family:宋体">                {{yanshouResult}}
                </div>
              </td>
            </tr>
            <tr style="height:66.5500pt;">
              <td width=549 valign=top colspan=5 style="width:411.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal style="margin-top:10px;line-height:12.0000pt;"><span style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font face="宋体">有异议的意见和说明理由：</font></span><span style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:0.0000pt;"></span>
                </p>
                <p>
<!--                  <a-form-item label="">-->
<!--                  <a-textarea name="saysth" rows="3" cols="30" class="inputclass shurukuang" v-decorator="['ysxzObjection']"-->
<!--                            style="width: 100%;text-align: left"></a-textarea>-->
<!--                  </a-form-item>-->
                  {{model.ysxzObjection}}
                </p>
              </td>
            </tr>
            <tr style="height:51.6000pt;">
              <td width=549 valign=top colspan=5 style="width:411.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal style="margin-top:10px;line-height:12.0000pt;"><span style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font face="宋体">组长签字：</font>
                  <span v-if="baogao_yiyizuzhang.showQrCodediv && genQcode">
                     <a-button type="primary"  @click="QrCode_baogao(baogao_yiyizuzhang)">生成二维码,请扫码签字</a-button>
                    <QrCode
                      :visible="baogao_yiyizuzhang.showQrCode"
                      :id="'QrCodebaogao_yiyizuzhang'"
                      :title="baogao_yiyizuzhang.qrtitle"
                      :text='baogao_yiyizuzhang.qrtext'
                      @onClose="()=>baogao_yiyizuzhang.showQrCode=false"/>
                  </span>
                </span>
                  <br/>
                <div class="image-container" v-for="(item,i) in baogao_yiyizuzhang.img">
                  <img   :src="item.elSign" style="width:180px"/>
                </div>
<!--                  <a-form-item label="">-->
<!--                  <a-input type="text" class="inputclass shurukuang" v-decorator="['ysxzHeadman']" style="width: 100%;" />-->
<!--                  </a-form-item>-->
                </p>
                <p class=MsoNormal style="line-height:12.0000pt;"><span style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;</span></p>
                <p class=MsoNormal style="line-height:12.0000pt;"><span style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';
font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font face="宋体">成员签字：</font>
                <span v-if="baogao_yiyichengyuan.showQrCodediv && genQcode">
                     <a-button type="primary"  @click="QrCode_baogao(baogao_yiyichengyuan)">生成二维码,请扫码签字</a-button>
                    <QrCode
                      :visible="baogao_yiyichengyuan.showQrCode"
                      :id="'QrCodebaogao_yiyichengyuan'"
                      :title="baogao_yiyichengyuan.qrtitle"
                      :text='baogao_yiyichengyuan.qrtext'
                      @onClose="()=>baogao_yiyichengyuan.showQrCode=false"/>
                </span>
                </span>
<!--                  <a-form-item label="">-->
<!--                  <a-input type="text" class="inputclass shurukuang" v-decorator="['ysxzMembers']" style="width: 100%;" />-->
<!--                  </a-form-item>-->
                </p>
                <div class="image-container" v-for="(item,i) in baogao_yiyichengyuan.img">
                  <img   :src="item.elSign" style="width:180px"/>
                </div>
              </td>
            </tr>


            <tr style="height:34.7500pt;">
              <td width=765 valign=center colspan=6
                  style="width:459.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal style="line-height:12.0000pt;">
               <span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;color:#000">监督人员或其他相关人员签字：</span>
                  <span v-if="baogao_jiandu.showQrCodediv && genQcode">
                     <a-button type="primary"  @click="QrCode_baogao(baogao_jiandu)">生成二维码,请扫码签字</a-button>
                    <QrCode
                      :visible="baogao_jiandu.showQrCode"
                      :id="'QrCodebaogao_jiandu'"
                      :title="baogao_jiandu.qrtitle"
                      :text='baogao_jiandu.qrtext'
                      @onClose="()=>baogao_jiandu.showQrCode=false"/>
                </span>
                <div class="image-container" v-for="(item,i) in baogao_jiandu.img">
                  <img   :src="item.elSign" style="width:180px"/>
                </div>
                </p>
              </td>
            </tr>
<!--            <tr style="height:34.7500pt;">-->
<!--              <td width=765 valign=center colspan=6-->
<!--                  style="width:459.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">-->
<!--                <p class=MsoNormal style="line-height:12.0000pt;">-->
<!--                  <span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">受邀质量、技术检测机构意见（盖章）：</span>-->
<!--                  <span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">-->
<!--                    <a-form-item label="">-->
<!--							&nbsp; <a-textarea name="saysth" rows="3" cols="30" class="inputclass shurukuang" v-decorator="['jsjcjgyj']" style="color:black;font-size:16px;width: 100%;"/>-->
<!--                    </a-form-item>-->
<!--						</span>-->
<!--                </p>-->
<!--              </td>-->
<!--            </tr>-->
            <tr style="height:54.3500pt;">
              <td width=378 valign=top colspan=3
                  style="width:227.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal>
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">履约验收科签字：</span>
                  <span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;mso-hansi-font-family:宋体;mso-bidi-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                    <div style="    height: 120px;
    text-align: center;
    letter-spacing: 8px;
    line-height: 113px;
    font-size: 24px;
    font-family: 宋体;">
             {{model.lyysIdea}}
                      </div>
						</span>
                </p>
               <!-- <p class=MsoNormal align=right style="mso-char-indent-count:5.0000;text-align:right;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">时间：</span>
                  <span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                    <a-form-item label="">
							&nbsp;							<a-input type="text" class="inputclass shurukuang" v-decorator="['lyysTime']" style="width: 100%;"/>
                    </a-form-item>

						</span>
                </p>-->
              </td>
              <td width=386 valign=top colspan=3
                  style="width:231.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <div style="position: relative;margin-bottom:10px;">
                <p class=MsoNormal>
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">资产与实验室管理处负责人签字或盖章：</span>

                </p>
                <p class=MsoNormal style="margin-left:60px;margin-top:15px;">
                  <img style="width:130px"  :src="getAvatarView(zcglcfzr)"/>

                </p>
                  <p class=MsoNormal style="margin-left:120px;margin-top:10px;">
                    <font
                      face="宋体" style="font-size:20px;color:black">{{zcglcfzrsj}}</font></p>

                  <div style="width: 90px;
    font-size: 12pt;
    position: absolute;
    left: 152px;
    top: 22px;
    font-family: 黑体;">
                    <img lang="EN-US" style="width:120px;font-size:12.0pt;font-family:黑体;opacity:0.8" :src="getAvatarView(zcglcfzrgz)">
                </div>

                </div>
              </td>
            </tr>
            <tr style="height:22.4500pt;">
              <td width=765 valign=center colspan=6
                  style="width:459.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal style="line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">备注：</span>
                  <span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                    <a-form-item label="">
													&nbsp; <a-textarea name="saysth" rows="3" cols="30" class="inputclass shurukuang" v-decorator="['ysbgRemarks']"
                                           style="width: 100%;"></a-textarea>	&nbsp;
                    </a-form-item>
						</span>
                </p>
              </td>
            </tr>
          </table>
          <p class=MsoNormal align="center" style="text-align: center;">
			<span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:10.0000pt;mso-font-kerning:0.0000pt;">

			</span>
          </p>
        </div>
      </a-form>
    </div>
  </a-spin>
</template>

<script>
  import {getAction} from '@/api/manage'
  import pick from 'lodash.pick'
  //import {validateDuplicateValue} from '@/utils/util'
  //import QRCode from "qrcodejs2"
  //import { formatDate } from '@/utils/util'
  //import QrCode from "../../sign_zcexpert/QrCode"
  import dayjs from 'dayjs';
  import moment from 'moment'
  export default {
    name: 'UapsBudgetAddmainForm',
    components: {},
    props: {
      genQcode:{
        type:Boolean,
        default:false
      },
      //流程表单data
      formData: {
        type: Object,
        default: () => {
        },
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        showQrCode:false,
        qrcodeText:'',
        zcglcfzr:'',
        zcglcfzrgz:'',
        zcglcfzrsj:'',
        qrcodeTitle:'',
        yanshou: {},
        isBeian:false,

        yanshouOptions: [{value: '1', label: '自行验收'}, {value: '2', label: '委托验收'}],

        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        domain:window.location.host,
        //项目执行单位初步验收意见 组长签字
        baogao_yiyizuzhang:{
          name:[],
          nameNum:1,//签名个数
          msg:[],
          qrtitle:"验收结论性意见组长签字",
          qrtext:"",
          field:"baogao_yiyizuzhang",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //项目执行单位初步验收意见 成员签字
        baogao_yiyichengyuan:{
          name:[],
          nameNum:-1,//签名个数
          msg:[],
          qrtitle:"验收结论性意见成员签字",
          qrtext:"",
          field:"baogao_yiyichengyuan",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //监督人员 成员签字
        baogao_jiandu:{
          name:[],
          nameNum:-1,//签名个数
          msg:[],
          qrtitle:"监督人员签字",
          qrtext:"",
          field:"baogao_jiandu",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //资产处负责人签字
        baogao_zccfuzheren:{
          name:[],
          nameNum:1,//签名个数
          msg:[],
          qrtitle:"资产处负责人签字",
          qrtext:"",
          field:"baogao_zccfuzheren",
          showQrCodediv:false,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        confirmLoading: false,
        packageId: '',
        ysbgNo:'',
        accId:'0',
        flowTitle:'履约验收报告审核',
        yanshouResult:'',
        validatorRules: {
          ysType: {
            rules: [
              {required: true, message: '请选择验收方式'},
            ]
          },
          acceptanceTime: {
            rules: [
              {required: true, message: '请选择验收日期'},
            ]
          },
          ysContent: {
            rules: [
              {required: true, message: '请填写验收内容'},
            ]
          },
          ysxzIdea: {
            rules: [
              {required: true, message: '请选择验收小组结论性意见'},
            ]
          },
          hasImport: {
            rules: [
              {required: true, message: '请选择有无进出口设备'},
            ]
          },
          bgsqb: {
            rules: [
              {required: true, message: '请上传变更申请表'},
            ]
          },
        },        fileIds: '',
        tableId: '',
        orgCode:'',
        planId:'',
        contractTime:null,//合同签订日期
        ysContentDefMsg:"",
        url: {
          add: "/uaps_project_acceptance/uapsProjectAcceptance/add",
          edit: "/uaps_project_acceptance/uapsProjectAcceptance/editYSBG",
          queryById: "/uaps_budget_addmain/uapsBudgetAddmain/queryById"
        }
      }
    },
    computed: {
      formDisabled() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return true
          }
        }
        return false
      }
    },
    created() {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
      setTimeout(()=>{
        this.getDataById();
      },500);
    },
    methods: {
      getSignImg: function (avatar) {
        if(avatar.name.length>0){
          return getFileAccessHttpUrl(avatar.name[0].sign);
        }
        return null;
      },
      getSignTime: function (avatar) {
        if(avatar.name.length>0){
          return avatar.name[0].time;
        }
        return null;
      },
      disabledYanShouDate(val){
        //验收日期时间设
        let finishDate=this.model.projectFinishtime;
        return val < moment(finishDate, 'YYYY-MM-DD').endOf('day')
        //return val < moment(finishDate, 'YYYY-MM-DD').endOf('day') || val > moment().endOf('day')
      },
      // 导出word方法
      exportWordFile() {
        let params = {
          planId : this.planId,packageId:this.packageId,id:this.accId,orgCode:this.orgCode
        };
        downloadFile('/uaps_project_acceptance/uapsProjectAcceptance/exportWordReport', "山东师范大学招标采购项目验收报告.docx",params);
      },
      add() {
        this.edit({});
      },
      edit(record) {
        let that=this;
        if(record.isFuyan==1){
          // record.ysContent=null;
          // record.ysType=null;
          // record.acceptanceTime=null;
          // record.ysxzObjection=null;
        }
        this.form.resetFields();
        this.model = Object.assign({}, record);


        if(record.isBa=="1"){
          this.isBeian=true;
        }
        else{
          this.isBeian=false;
        }
        this.contractTime=record.contractTime;
        this.packageId = record.packageNo;
        this.tableId = record.packageNo;
        this.planId=record.planId,
        this.orgCode=record.sysOrgCode;
        // this.getdownload(record.shqdFile);
          this.accId=record.id;
        if(record.flowTitle!=null){
          this.flowTitle=record.flowTitle;
        }
        this.yanshou.acceptanceTime=record.acceptanceTime;
        if(record.acceptanceTime!=null){
          this.isSave=true;
        }

        this.ysbgNo=record.ysbgNo;
        this.yanshou.ysType=record.ysType;
        this.yanshou.acceptanceETime=record.acceptanceETime;
        this.yanshou.supplementaryNotes=record.supplementaryNotes;
        if(record.ysxzIdea=='1'){
          this.yanshouResult='合格';
        }
        else if(record.ysxzIdea=='2'){
          this.yanshouResult='基本合格';
        }
        else if(record.ysxzIdea=='3'){
          this.yanshouResult='不合格';
        }

          if(this.model.projectType=='服务'){
              this.titleType='(服务类)';
          }else if(this.model.projectType=='货物'){
              this.titleType='(货物类)';
          }else if(this.model.projectType=='工程'){
              this.titleType='(工程类)';
          }


        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'budgetAddmainCode','jsjcjgyj','ysbgRemarks'))
          // this.form.setFieldsValue(pick(this.model, 'budgetAddmainCode','budgetAddmainName','zbdw','zbPrice', 'projectType', 'projectFinishtime', 'ysType', 'acceptanceTime', 'ysContent','ysxzIdea','ysxzObjection','ysxzObjectionName','ysxzHeadman','ysxzMembers','xmzxdwIdea','xmzxdwCyry','projectFuzheQianzi','projectFuzhePhone','danweiFuzhe','jdryqz','jsjcjgyj','lyysIdea','lyysTime','zcglcIdea','zcglcTime','ysbgRemarks'))

        })
        getAction("/uaps_budget_addmainmaster/uapsBudgetAddmainmaster/selectGZQianMsgTimeByTableId",{tableid:this.accId}).then((res)=>{
          this.zcglcfzrsj='';
          this.zcglcfzr='';
          this.zcglcfzrgz='';
          res=res.data;
          if(res.success){
            if(res.result){
              var listmap = res.result;
              for(var i=0;i<listmap.length;i++){
                if (listmap[i].keyName=="ysbgsh_lyysfgfcz"){
                  this.zcglcfzr=listmap[i].Qian;
                  this.zcglcfzrgz=listmap[i].GZ;
                  //this.zcglcfzrsj=formatDate(listmap[i].submitTime,'yyyy-MM-dd');
                  this.zcglcfzrsj = dayjs(listmap[i].submitTime).format('YYYY-MM-DD');
                }
              }
            }
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          //that.confirmLoading = false;
        })
        this.getSign();
      },

      //获取基本信息
      GetQueryString(name)
      {
        var a = decodeURI(window.location.search)
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = a.substr(1).match(reg);
        if(r!=null)return unescape(r[2]); return null;
      },
      getDataById(){
        if(this.genQcode==false){
          let packageId=this.GetQueryString("packageId");
          let planId=this.GetQueryString("planId");
          let accId=this.GetQueryString("accId");
          let sorgcode=this.GetQueryString("orgCode");
          if(packageId!=null && planId!=null && accId!=null){
            this.confirmLoading = true;
            getAction('/uaps_project_acceptance/uapsProjectAcceptance/queryProjectContentByAccId', {accId:accId}).then((res) => {
              res=res.data;
              if (res.success) {
                this.confirmLoading = false;
                res.result.packageNo=packageId;
                // res.result.id=id;
                this.edit(res.result);
              }
              if (res.code === 510) {
                this.$message.warning(res.message)
              }
            })
          }


        }
      },
      //获取签名信息
      getSign(){
        //组长签字
        this.Sign(this.baogao_yiyizuzhang);
        //成员签字
        this.Sign(this.baogao_yiyichengyuan);
        //监督成员签字
        this.Sign(this.baogao_jiandu);
        //资产处负责人签字
        //this.Sign(this.baogao_zccfuzheren);
        this.getFlowSign(this.baogao_zccfuzheren,'履约验收分管副处长审核');

      },
      //获取手动上传签名
      getFlowSign(obj,name){
        let url="/uaps_project_acceptance/uapsProjectAcceptance/getSignByAccId";
        let params={accId:this.accId,title:this.flowTitle};
        obj.name.length=0;
        getAction(url, params).then((res) => {
          if (res.success) {
            if(res.result.length>0){
              let records=res.result;
              // console.log(records);
              for(let i=0;i<records.length;i++){
                if(records[i].name==name){
                  let sign={"name":records[i].name,"sign":records[i].Qian,"time":moment(records[i].submitTime).format('ll')};
                  obj.name.push(sign);
                }

              }
              //判断是否已经签字 -1 为不限制签名个数
              if(obj.nameNum!=-1 && records.length>=obj.nameNum){
                obj.showQrCodediv=false;
              }
            }
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
        })
      },
      Sign(obj){
        let url="/uaps_ele_signature/uapsEleSignature/listmobile";
        let params={projectId:this.tableId,filedName:obj.field,accId:this.accId,sysOrgCode:this.orgCode};
        // if(!this.isBeian){
        //   params={projectId:this.tableId,accId:this.accId};
        // }
        obj.msg.length=0;
        obj.name.length=0;
        getAction(url, params).then((res) => {
          res=res.data;
          if (res.success) {
            if(res.result.records.length>0){
              let records=res.result.records;
              for(let i=0;i<records.length;i++){
                let imgBase64=records[i].elSign;
                obj.name.push(imgBase64);
                obj.img.push(records[i])

              }
              //判断是否已经签字 -1 为不限制签名个数
              if(obj.nameNum!=-1 && records.length>=obj.nameNum){
                obj.showQrCodediv=false;
              }
            }
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
        })
      },
      //生成二维码
      QrCode_baogao(obj){
        //已经保存过数据，直接生成二维码
        if(this.isSave){
          let qrcodetxt='/expertConfirmInfo?infoType=report&accId='+this.accId+'&orgCode='+this.orgCode+'&planId='+this.planId+'&packageId='+this.packageId+'&id='+this.tableId+'&field='+obj.field;
          let time = parseInt(new Date().getTime() / 1000);
          obj.qrtext='http://'+this.domain+qrcodetxt+'&time='+time;
          obj.showQrCode=true;
        }
        else{
          const that = this;
          // 触发表单验证,数据项必须填写完整，才能生成二维码，否则查看二维码信息内容为空

          this.form.validateFields((err, values) => {
            if (!err) {
              that.confirmLoading = true;
              let httpurl = '';
              let method = '';
              httpurl += that.url.edit;
              method = 'post';
              let formData = Object.assign(that.model, values);
              httpAction(httpurl, formData, method).then((res) => {
                if (res.success) {
                  // let msg=res.message;
                  // let msgArray=msg.split(',');
                  // that.accId=msgArray[1];
                  let qrcodetxt='/expertConfirmInfo?infoType=applybeian&accId='+that.accId+'&orgCode='+that.orgCode+'&planId='+that.planId+'&packageId='+that.packageId+'&id='+that.tableId+'&field='+obj.field;
                  let time = parseInt(new Date().getTime() / 1000);
                  obj.qrtext='http://'+this.domain+qrcodetxt+'&time='+time;
                  obj.showQrCode=true;

                  that.isSave=true;
                }
              }).finally(() => {
                that.confirmLoading = false;
              })
            }
            else{
              that.$message.error("信息填写不完整,请填写必填项，然后在生成二维码");
            }
          })

        }
      },
      getAvatarView: function (avatar) {
        //return getFileAccessHttpUrl(avatar)
      },
      //渲染流程表单数据
      showFlowData() {
        if (this.formBpm === true) {
          let params = {id: this.formData.dataId};
          getAction(this.url.queryById, params).then((res) => {
            res=res.data;
            if (res.success) {
              this.edit(res.result);
            }
          });
        }
      },
      removeImg(id){
        var that=this;
        deleteAction('/uaps_ele_signature/uapsEleSignature/deletemobile', {id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.baogao_yiyizuzhang={
              name:[],
                nameNum:1,//签名个数
                msg:[],
                qrtitle:"验收结论性意见组长签字",
                qrtext:"",
                field:"baogao_yiyizuzhang",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //项目执行单位初步验收意见 成员签字
            that.baogao_yiyichengyuan={
              name:[],
                nameNum:-1,//签名个数
                msg:[],
                qrtitle:"验收结论性意见成员签字",
                qrtext:"",
                field:"baogao_yiyichengyuan",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //监督人员 成员签字
            that.baogao_jiandu={
              name:[],
                nameNum:-1,//签名个数
                msg:[],
                qrtitle:"监督人员签字",
                qrtext:"",
                field:"baogao_jiandu",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //资产处负责人签字
            that.baogao_zccfuzheren={
              name:[],
                nameNum:1,//签名个数
                msg:[],
                qrtitle:"资产处负责人签字",
                qrtext:"",
                field:"baogao_zccfuzheren",
                showQrCodediv:false,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            that.getSign();

          } else {
            that.$message.warning(res.message);
          }
        });
      },
      submitForm() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            httpurl += that.url.edit;
            method = 'post';
            let formData = Object.assign(that.model, values);
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
          else{
            that.$message.warning("信息填写不完整,请核对必填项");
          }
        })
      },

      getdownload(fileIds) {
        if (fileIds != "" && fileIds != null) {
          let sqsjData = JSON.parse(fileIds);
          this.fileIds = [];
          for (let i = 0; i < sqsjData.length; i++) {
            this.fileIds.push(sqsjData[i]);
          }
        }
      },
      download(fileName, id) {
        downloadFile('/file/download/', fileName, {fileId: id});
      },
      deleteAction(id) {
        this.fileIds.splice(this.fileIds.findIndex(e => e.fileid == id), 1)
      },
    }
  }
</script>
<style scoped>
  .lineh{
    padding: 8px 4px;
  }
  .inputclass {
    border: none;
    outline: none
  }

  p.MsoNormal {
    mso-style-name: 正文;
    mso-style-parent: "";
    margin: 0pt;
    margin-bottom: .0001pt;
    font-family: 'Times New Roman';
    mso-fareast-font-family: 宋体;
    font-size: 10.0000pt;
  }

  span.10
  {
    font-family: 等线
  ;
  }

  span

  .15
  {
    font-family: 等线
  ;
    font-size: 9.0000pt
  ;
  }

  span

  .16
  {
    font-family: 等线
  ;
    font-size: 9.0000pt
  ;
  }
  p{
    margin-bottom: 0px !important;
  }
  p.MsoHeader {
    mso-style-name: 页眉;
    mso-style-noshow: yes;
    margin: 0pt;
    margin-bottom: .0001pt;
    border-bottom: 1.0000pt solid windowtext;
    mso-border-bottom-alt: 0.7500pt solid windowtext;
    padding: 0pt 0pt 1pt 0pt;
    layout-grid-mode: char;
    mso-pagination: none;
    text-align: center;
    font-family: 等线;
    mso-bidi-font-family: 'Times New Roman';
    font-size: 9.0000pt;
    mso-font-kerning: 1.0000pt;
  }

  p.MsoFooter {
    mso-style-name: 页脚;
    mso-style-noshow: yes;
    margin: 0pt;
    margin-bottom: .0001pt;
    layout-grid-mode: char;
    mso-pagination: none;
    font-family: 等线;
    mso-bidi-font-family: 'Times New Roman';
    font-size: 9.0000pt;
    mso-font-kerning: 1.0000pt;
  }

  span.msoIns {
    mso-style-type: export-only;
    mso-style-name: "";
    text-decoration: underline;
    text-underline: single;
    color: blue;
  }

  span.msoDel {
    mso-style-type: export-only;
    mso-style-name: "";
    text-decoration: line-through;
    color: red;
  }

  table.MsoNormalTable {
    mso-style-name: 普通表格;
    mso-style-parent: "";
    mso-style-noshow: yes;
    mso-tstyle-rowband-size: 0;
    mso-tstyle-colband-size: 0;
    mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
    mso-para-margin: 0pt;
    mso-para-margin-bottom: .0001pt;
    mso-pagination: widow-orphan;
    font-family: 'Times New Roman';
    font-size: 10.0000pt;
    mso-ansi-language: #0400;
    mso-fareast-language: #0400;
    mso-bidi-language: #0400;
  }

  @page {
    mso-page-border-surround-header: no;
    mso-page-border-surround-footer: no;
  }

  @page Section0 {
    margin-top: 72.0000pt;
    margin-bottom: 72.0000pt;
    margin-left: 90.0000pt;
    margin-right: 90.0000pt;
    size: 595.3000pt 841.9000pt;
    layout-grid: 15.6000pt;
  }

  div.Section0 {
    page: Section0;
  }
  .shurukuang{
    border: none !important;
    resize:none;
    /*text-align: center;*/
    background-color: #FFFFFF;
  }
  .ant-input-disabled {
    background-color: #fff !important;
    color: #000 !important;
  }
  .image-container {
    position: relative;
    display: inline-block;
  }

  .delete-button {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: #cacaca;
    color: #000000;
    font-size: 12px;
    padding: 5px;
    cursor: pointer;
    user-select: none;
  }

  .image-container:hover .delete-button {
    display: block;
  }

</style>
